import { NoticeStatus } from 'store/ducks/notice/types';
import store from 'store/store';
import * as noticeActions from '../store/ducks/notice/actions';

export const ShowNotification = (message: string, status?: NoticeStatus) => {
	store.dispatch(noticeActions.showNotice({ message, status }));
};
